// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"dd62f2fd","232":"380abafa","464":"dd62f2fd","532":"4f94b41b"}[chunkId] + ".chunk.css";
};